import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthPasswordService } from '../../services/auth-password.service';
import { KeycloakService } from 'keycloak-angular';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../../shared/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-login',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, RouterLink, MatIconModule, MatDialogModule],
    template: `
  <div class="login-wrap">
    <div class="card">
      <h2 class="title">EasyStore App</h2>
      <p class="subtitle">by Bitthing.cl</p>
      <p class="heading">Inicia sesión en tu cuenta</p>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <label class="label">Usuario o correo</label>
        <input class="input" formControlName="username" type="text" autocomplete="username" />

        <label class="label">Contraseña</label>
        <div class="password-wrap">
          <input class="input" [type]="showPass ? 'text' : 'password'" formControlName="password" autocomplete="current-password" />
          <button type="button" class="eye" (click)="toggle()" aria-label="Mostrar u ocultar contraseña">
            <mat-icon>{{ showPass ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </div>

        <button class="btn primary" [disabled]="form.invalid || loading" type="submit">
          {{ loading ? 'Ingresando…' : 'Iniciar sesión' }}
        </button>
      </form>

      <div class="alt-actions">
        <a routerLink="/auth/forgot-password" class="link">¿Olvidaste tu contraseña?</a>
      </div>
    </div>

    <div class="overlay" *ngIf="loading">
      <div class="spinner"></div>
      <div class="msg">Procesando…</div>
    </div>
  </div>
  `,
    styles: [`
    .login-wrap{display:flex;align-items:flex-start;justify-content:center;min-height:80vh;padding:24px;background:#e7efe7}
    .card{max-width:420px;width:100%;background:#fff;border-radius:12px;box-shadow:0 8px 20px rgba(0,0,0,.08);padding:24px}
    .title{margin:0 0 2px 0;font-size:22px;font-weight:800;color:#374151}
    .subtitle{margin:0 0 2px 0;color:#6b7280;font-size:13px}
    .heading{margin:6px 0 16px 0;color:#6b7280}
    .label{display:block;margin:12px 0 6px;color:#374151}
    .input{width:100%;padding:12px;border:1px solid #d1d5db;border-radius:8px;background:#fff}
    .password-wrap{position:relative}
    .password-wrap .eye{position:absolute;right:8px;top:50%;transform:translateY(-50%);border:none;background:transparent;cursor:pointer;color:#6b7280;display:flex;align-items:center}
    .btn{appearance:none;border:none;border-radius:8px;padding:12px 16px;background:#f3f4f6;color:#111827;font-weight:600;cursor:pointer;text-decoration:none}
    .btn.primary{width:100%;background:var(--primary);color:#fff;margin-top:16px}
    .btn:hover{filter:brightness(.98)}
    .alt-actions{margin-top:12px;display:flex;justify-content:flex-end}
    .link{color:#374151;text-decoration:underline}
    .overlay{position:fixed;inset:0;background:rgba(255,255,255,.6);backdrop-filter:blur(2px);display:flex;flex-direction:column;align-items:center;justify-content:center;z-index:9999}
    .spinner{width:44px;height:44px;border-radius:50%;border:4px solid #fde68a;border-top-color:var(--primary);animation:spin 1s linear infinite}
    .msg{margin-top:12px;color:var(--primary);font-weight:700}
    @keyframes spin{to{transform:rotate(360deg)}}
  `]
})
export class LoginComponent {
    form = this.fb.group({
        username: ['', [Validators.required]],
        password: ['', [Validators.required]],
    });
    loading = false;
    showPass = false;

    constructor(private fb: FormBuilder, private auth: AuthPasswordService, private kc: KeycloakService, private dialog: MatDialog) { }

    toggle() { this.showPass = !this.showPass; }

    async ngOnInit() {
        // Si ya hay sesión activa, redirigir al panel
        try {
            const logged = await this.kc.isLoggedIn();
            if (logged) { window.location.href = '/admin'; return; }
        } catch {}
    }

    async onSubmit() {
        if (this.form.invalid || this.loading) return;
        this.loading = true;
        const { username, password } = this.form.value as any;
        try {
            await this.auth.loginWithPassword(username, password);
            window.location.href = '/admin';
        } catch (e) {
            console.error('Login error', e);
            this.dialog.open(AlertDialogComponent, {
                data: {
                    title: 'Contraseña incorrecta',
                    message: 'No se pudo iniciar sesión. Verifique sus credenciales.',
                    hint: 'Asegúrate de que el correo y la contraseña sean correctos.',
                    icon: 'lock',
                    color: 'warn',
                    okLabel: 'Entendido'
                }
            });
        } finally {
            this.loading = false;
        }
    }
}